// @flow
import { useSelector } from 'react-redux';

export default function useReactions() {
    const reactionArray = useSelector((state: any) => state.reactionsList);
    const reactionLookup = useSelector((state: any) => state.reactionsLookup);

    const getReactionForId = (id: number) => {
        return reactionLookup[id];
    };

    const getSupportedReactions = () => {
        return reactionArray;
    };

    const isSupportedReaction = (reactionId: number) => {
        const supportedReactions = getSupportedReactions();
        return supportedReactions.indexOf(reactionId) > -1;
    };

    return {
        getReactionForId,
        getSupportedReactions,
        isSupportedReaction
    };
}



// WEBPACK FOOTER //
// ./src/v5/messaging/components/hooks/useReactions.js